import { Tooltip } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Container = styled.div`
  width: 70%;
  height: 100%;
`

export const CustomButton = styled(ButtonMui)`
  width: 6.5rem;    
  height: 2.5rem !important;
  margin: 0 !important;
`
export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
`
export const CustomTooltip = styled(Tooltip)``

export const AddBatchesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: .5rem;
`
